import { createAction } from 'typesafe-actions';
import { LocationEnum } from './location.types';

export const updateCurrentLocationRoute = createAction('UPDATE_LOCATION', ({ location }): LocationEnum => location)<
    any
>();
